import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ groupParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `group/getSearched`,
      params: groupParams,
    });
    const allGroup = data;
    yield put(Actions.setAll({ allGroup }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllFactoryGroups({ factoryId }) {
  try {
    const { data } = yield call(api.get, {
      route: `group/getgroupsbyfactory/` + factoryId,
    });
    const factoryGroups = data;
    yield put(Actions.setAllFactoryGroups({ factoryGroups }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateGroup({ groupData, actionName, groupParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === 'Update' ? api.put : api.post, {
      route: `group`,
      data: groupData,
    });
    yield put(Actions.fetchAll({ groupParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD ? CONSTANT_VARIABLES.GROUP_CREATED : CONSTANT_VARIABLES.GROUP_UPDATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteGroup({ id, groupParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `group/${id}`,
    });
    yield put(Actions.fetchAll({ groupParams }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.FETCH_ALL_BY_FACTORY_ID, fetchAllFactoryGroups),
    takeLatest(ActionTypes.ADD_OR_UPDATE_GROUP, addorUpdateGroup),
    takeLatest(ActionTypes.DELETE_GROUP, deleteGroup),
  ]);
}
